import { ref } from "vue";
import { useConfig } from "./useConfig";
const checkboxItems = ref();
export function useTopicsDropdown() {
    const { topics } = useConfig();
    checkboxItems.value = topics?.value?.map(topic => ({
        id: topic.id,
        value: topic.id,
        title: topic.tName,
        checked: false
    }));
    checkboxItems.value?.unshift({
        id: "all",
        checked: true,
        title: "Alle Themen",
        value: "all"
    });
    const updateCheckbox = (index, isChecked) => {
        if (checkboxItems.value) {
            const selectedItem = checkboxItems.value[index];
            if (selectedItem.id === "all") {
                checkboxItems.value.forEach(item => item.checked = false);
                selectedItem.checked = true;
            }
            else {
                checkboxItems.value[0].checked = false;
                selectedItem.checked = isChecked;
            }
        }
    };
    const unCheckItem = (id) => {
        const selectedIndex = checkboxItems.value?.findIndex(x => x.id === id);
        if (selectedIndex) {
            updateCheckbox(selectedIndex, false);
            const hasCheckOne = checkboxItems.value?.find(item => item.checked === true);
            if (!hasCheckOne) {
                updateCheckbox(0, true);
            }
        }
    };
    const clearCheckboxes = () => {
        if (checkboxItems.value) {
            checkboxItems.value = checkboxItems.value.map(item => {
                item.checked = item.id === "all" ? true : false;
                return item;
            });
        }
    };
    return {
        checkboxItems,
        updateCheckbox,
        unCheckItem,
        clearCheckboxes
    };
}
